import {ExpenseApprovalStatus, ExpenseReimbursementStatus} from "./@types";
import {PaletteStatus} from "../../gd/skin/colors/@types";

export const ExpenseApprovalStatusOptions = [

    {
        value   : ExpenseApprovalStatus.PENDING,
        label   : "Pending",
        color   : PaletteStatus.BLUE
    },
    {
        value   : ExpenseApprovalStatus.APPROVED,
        label   : "Approved",
        color   : PaletteStatus.GREEN
    },
    {
        value   : ExpenseApprovalStatus.REJECTED,
        label   : "Rejected",
        color   : PaletteStatus.RED
    },

]



export const ExpenseReimbursementStatusOptions= [
    {
        value   : ExpenseReimbursementStatus.PENDING,
        label   : "Pending",
        color   : PaletteStatus.BLUE
    },
    {
        value   : ExpenseReimbursementStatus.REIMBURSED,
        label   : "Reimbursed",
        color   : PaletteStatus.GREEN
    },
    {
        value   : ExpenseReimbursementStatus.NOT_REIMBURSABLE,
        label   : "Not reimbursable",
        color   : PaletteStatus.GRAY
    },
    // {
    //     value   : ExpenseReimbursementStatus.REJECTED,
    //     label   : "Rejected",
    //     color   : 3
    // },
]